export default "__VITE_ASSET__BNwXjLnV__"